/**
 * 全站页脚文案（与 HeadNav 语言一致：en / es / hi / pt / id）
 */
export default {
  en: {
    tagline: 'Your trusted source for modified WhatsApp',
    mainTitle: 'Main',
    modsTitle: 'WhatsApp Mods',
    legalTitle: 'Legal & Info',
    home: 'Home',
    download: 'Download',
    blogs: 'Blogs',
    contact: 'Contact',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    dmca: 'DMCA',
    disclaimer: 'Disclaimer',
    rights: 'All rights reserved.',
  },
  es: {
    tagline: 'Tu fuente de confianza para WhatsApp modificado',
    mainTitle: 'Principal',
    modsTitle: 'Mods de WhatsApp',
    legalTitle: 'Legal e información',
    home: 'Inicio',
    download: 'Descargar',
    blogs: 'Blog',
    contact: 'Contacto',
    privacy: 'Política de privacidad',
    terms: 'Términos del servicio',
    dmca: 'DMCA',
    disclaimer: 'Aviso legal',
    rights: 'Todos los derechos reservados.',
  },
  hi: {
    tagline: 'संशोधित WhatsApp के लिए आपका भरोसेमंद स्रोत',
    mainTitle: 'मुख्य',
    modsTitle: 'WhatsApp MOD',
    legalTitle: 'कानूनी व जानकारी',
    home: 'होम',
    download: 'डाउनलोड',
    blogs: 'ब्लॉग',
    contact: 'संपर्क',
    privacy: 'गोपनीयता नीति',
    terms: 'सेवा की शर्तें',
    dmca: 'DMCA',
    disclaimer: 'अस्वीकरण',
    rights: 'सर्वाधिकार सुरक्षित।',
  },
  pt: {
    tagline: 'Sua fonte confiável para WhatsApp modificado',
    mainTitle: 'Principal',
    modsTitle: 'Mods do WhatsApp',
    legalTitle: 'Legal e informações',
    home: 'Casa',
    download: 'Baixar',
    blogs: 'Blog',
    contact: 'Contato',
    privacy: 'Política de privacidade',
    terms: 'Termos de uso',
    dmca: 'DMCA',
    disclaimer: 'Aviso legal',
    rights: 'Todos os direitos reservados.',
  },
  id: {
    tagline: 'Sumber terpercaya untuk WhatsApp yang dimodifikasi',
    mainTitle: 'Utama',
    modsTitle: 'MOD WhatsApp',
    legalTitle: 'Hukum & info',
    home: 'Beranda',
    download: 'Unduh',
    blogs: 'Blog',
    contact: 'Kontak',
    privacy: 'Kebijakan privasi',
    terms: 'Ketentuan layanan',
    dmca: 'DMCA',
    disclaimer: 'Penyangkalan',
    rights: 'Hak cipta dilindungi.',
  },
};
